import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon, Checkbox } from 'antd'

@inject((store: any) => {
    const { popupStore, couponTypesStore, servicesStore, subscriptionsStore } = store
    return { popupStore, couponTypesStore, servicesStore, subscriptionsStore }
})
@observer
export default class SubscriptionsList extends Component<any, any> {
    selectAllSubs = () => {
        const {
            subscriptionsStore: { subscriptions },
            couponTypesStore: { changeEditValue }
        } = this.props
        let joinedSubs = []
        subscriptions.forEach(sub => joinedSubs.push(sub.id))
        changeEditValue('subscriptions', `[${joinedSubs.join(',')}]`)
    }
    render() {
        const subTypes = {
            COUPLE_OLD_PLUS: 'זוגי - גיל הזהב - פלוס',
            FAMILY_PLUS: 'משפחתי - פלוס',
            COUPLE_PLUS: 'זוגי - פלוס',
            PERSONAL_PLUS: 'אישי - פלוס',
            COUPLE_OLD: 'זוגי - גיל הזהב',
            FAMILY: 'משפחתי',
            COUPLE: 'זוגי',
            PERSONAL: 'אישי',
            AGENT: 'סוכן',
            PERSONAL_OLD: 'אישי - גיל הזהב'
        }
        const {
            subscriptionsStore: { subscriptions },
            couponTypesStore: {
                changeEditValue,
                editCouponType: { subscriptions: selectedSubs, iteration_charge }
            }
        } = this.props
        const subsArray = selectedSubs
            ? selectedSubs
                  .replace('[', '')
                  .replace(']', '')
                  .trim()
                  .split(',')
            : []
        return (
            <div style={{ backgroundColor: '#f0f2f5', padding: '1rem' }}>
                <h5>
                    <small>בחירת מנויים (נבחרו - {subsArray.length})</small>
                </h5>
                <div style={{ marginBottom: '1rem' }}>
                    <a style={{ marginLeft: '1rem' }} onClick={() => this.selectAllSubs()}>
                        <Icon type="check-square" /> <span style={{ textDecoration: 'underline' }}>בחר הכל</span>
                    </a>
                    <a onClick={() => changeEditValue('subscriptions', null)}>
                        <Icon type="close-square" /> <span style={{ textDecoration: 'underline' }}>נקה הכל</span>
                    </a>
                </div>
                <div style={{ maxHeight: '25vh', overflowX: 'hidden', overflowY: 'auto' }}>
                    {subscriptions.map(sub => {
                        const checked = subsArray.filter(selected => +selected === +sub.id).length
                        return (
                            (!iteration_charge || sub.iteration_type === 'MONTHLY') && (
                                <Checkbox
                                    checked={checked}
                                    onChange={e => {
                                        let value
                                        if (e.target.checked) {
                                            value = `[${[...subsArray, sub.id].join(',')}]`
                                        } else {
                                            value =
                                                subsArray.length > 1
                                                    ? `[${subsArray.filter(selected => +sub.id !== +selected)}]`
                                                    : null
                                        }
                                        changeEditValue('subscriptions', value)
                                    }}
                                    key={sub.id}
                                    style={{
                                        width: '100%',
                                        padding: '0.3rem 0',
                                        borderBottom: '1px solid #dedede'
                                    }}
                                >
                                    {sub.name} ({subTypes[sub.type]})
                                </Checkbox>
                            )
                        )
                    })}
                </div>
            </div>
        )
    }
}
